import { Container } from '@cgs/wge';
import { SLOT_SESSION_TOKEN, SlotSession, SlotSessionProperties } from '../common/slot_session';

export class StickyMaxBetProvider {
  private _slotSession: SlotSession;

  constructor(container: Container) {
    this._slotSession = container.resolve<SlotSession>(SLOT_SESSION_TOKEN);
    this._slotSession.propertyChanged.listen((property: SlotSessionProperties) => {
      if (this.isStickyBetAvailable) {
        if (property === SlotSessionProperties.UpdateMaxBet) {
          if (this._slotSession.isXtremeBetNow) {
            this._slotSession.setMaxFeatureBet();
          } else {
            this.updateMaxBet();
          }
        }
      }
    });
  }

  public get isStickyBetAvailable(): boolean {
    return true;
  }

  public updateMaxBet(): void {
    this._slotSession.setMaxBet();
  }
}
